import { useHistory } from 'react-router-dom';
import useTranslation from '../../../../hooks/useTranslations';

const FooterBar = () => {
	const t = useTranslation();

	return (
		<div className="z-40 flex items-center justify-center flex-shrink-0 w-screen h-18 lg:absolute lg:bottom-0 lg:inset-x-0 lg:h-14 bg-oly-gray-footerbar print:hidden">
			<nav className="flex flex-wrap items-center flex-1 h-full py-2 px-4 lg:px-2 lg:justify-center text-[0.8125rem] sm:text-[0.875rem] max-w-[1920px]">
				<div className="flex mr-3 text-oly-gray-lightest lg:mr-8">
					{`© Olympus ${(new Date().getFullYear())}`}
				</div>
				{process.env.REACT_APP_LINKS_IMPRINT && process.env.REACT_APP_LINKS_IMPRINT !== '' && (<FooterBarLink route={process.env.REACT_APP_LINKS_IMPRINT} title={t('webapp_footer_imprint')} />)}
				{process.env.REACT_APP_LINKS_TERMS && process.env.REACT_APP_LINKS_TERMS !== '' && (<FooterBarLink route={process.env.REACT_APP_LINKS_TERMS} title={t('webapp_footer_terms')} />)}
				{process.env.REACT_APP_LINKS_PRIVACY && process.env.REACT_APP_LINKS_PRIVACY !== '' && (<FooterBarLink route={process.env.REACT_APP_LINKS_PRIVACY} title={t('webapp_footer_privacy')} />)}
				{process.env.REACT_APP_LINKS_COOKIES && process.env.REACT_APP_LINKS_COOKIES !== '' && (<FooterBarLink route={process.env.REACT_APP_LINKS_COOKIES} title={t('webapp_footer_cookies')} />)}
				<div className="flex mr-3 lg:mr-8 text-oly-gray-dark last:mr-0">
					<a href="#cookieSettings" className="ot-sdk-show-settings transition duration-150 ease-in-out can-hover:hover:text-oly-orange-default focus-visible:text-oly-orange-default focus:outline-none">Cookies Settings</a>
				</div>
			</nav>
		</div>
	);
};

export default FooterBar;

const FooterBarLink = ({ route, title }) => {
	const history = useHistory();

	const pushRoute = (e) => {
		if (route?.includes('http') === false) {
			e.preventDefault();
			history.push(route);
		}
	};

	return (
		<div className="flex mr-3 lg:mr-8 text-oly-gray-dark last:mr-0">
			<a
				href={route}
				target="_blank"
				className="transition duration-150 ease-in-out can-hover:hover:text-oly-orange-default focus-visible:text-oly-orange-default focus:outline-none"
				onClick={(e) => pushRoute(e)}
				rel="noreferrer"
			>
				{title}
			</a>
		</div>
	);
};
